module.exports = __webpack_public_path__ + "assets/fonts/MiloOffc-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/milo-medium/MiloOffc-Medium.ttf
// module id = 519
// module chunks = 0